let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gP4AH")).then(() => parcelRequire('e3bFZ'));